export default __webpack_public_path__ + "static/media/wetland_sprinkler_close.aa4ab47d.jpg";